import ElementIdGenerator from './element_id_generator';

export default class BaseElement {
  constructor(managers, properties = {}) {
    this.managers = managers;
    this.id = properties.id || ElementIdGenerator.next();
    this.element = null; // Set by subclass
  }

  getSerializeBase() {
    return {
      id: this.id,
      left: this.element.style.left,
      top: this.element.style.top
    };
  }

  isTextElement() {
    return this.element.dataset.type === 'text';
  }

  isImageElement() {
    return this.element.dataset.type === 'image';
  }

  isLineElement() {
    return this.element.dataset.type === 'line';
  }

  isEditing() {
    return false;
  }
}
